import { Action, createReducer, on } from '@ngrx/store';
import { 
    fetchRecords,
    fetchRecordsSuccess,
    fetchRecordsFail,
    resetState
} from './workflow-failed-email.action';
import { WorkflowFailedEmail } from './workflow-failed-email.model';

export interface WorkflowFailedEmailRecordsState {
    listData: WorkflowFailedEmail[];
    singleData: WorkflowFailedEmail;
    loading: boolean;
    error: any;
    total: number;
}

export const initialState: WorkflowFailedEmailRecordsState = {
    listData: [],
    singleData: null,
    loading: false,
    error: null,
    total: 0
};


export const WorkflowFailedEmailRecordReducer = createReducer(

    initialState,
    on(fetchRecords, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(fetchRecordsSuccess, (state, { listData, total }) => {
        return { ...state, listData, total, loading: false };
    }),
    on(fetchRecordsFail, (state, { error }) => {
        return { ...state, error, loading: false };
    }),

    on(resetState, () => initialState)  // Reset action handler
    
);